import { CREATEJS_UTILITIES_LOGGER } from "../../../../../index";
import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger(CREATEJS_UTILITIES_LOGGER);

export function getSize(obj: any): number {
    switch (typeof obj) {
        case "boolean": return 4;
        case "number": return 8;
        case "string": return 2 * obj.length;
        case "object": return Object.keys(obj).reduce(
            (sum, key) => sum + getSize(key) + getSize(obj[key]), 0
        );
        default: return 0;
    }
}
